import {Component} from 'substance'

/**
 * @typedef Component.PlaceholderComponent.props
 * @property {bool} visible - Set to true to show the placeholder
 * @property {string} placeholder - Placeholder message
 */

/**
 * @typedef Component.PlaceholderComponent.state
 * @property {bool} visible - If the placeholder is shown
 */

/**
 * A placeholder component
 *
 * @private
 * @memberof Component
 *
 * @param {Component.PlaceholderComponent.props} props
 * @property {Component.PlaceholderComponent.props} props
 * @property {Component.PlaceholderComponent.state} state
 */
class PlaceholderComponent extends Component {

    getInitialState() {
        return {
            visible: this.props.visible === true
        }
    }

    render($$) {
        const el = $$('div').append(this.props.placeholder)
        if (this.state.visible) {
            el.addClass('im-placeholder-visible')
        }

        return el
    }
}

export default PlaceholderComponent
